import { Component, EventEmitter, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'app-stock-management-tabs',
    templateUrl: './stock-management-tabs.component.html',
    styleUrls: ['./stock-management-tabs.component.scss'],
    imports: [MatTabsModule, TranslateModule]
})
export class StockManagementTabsComponent {
    @Output() tabIndexChange = new EventEmitter<number>();
}
